import { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { DELETE_PROJECT, SET_EDIT_PROJECT_DIALOGUE_ID, } from '../actions/types';
import { siteboardAction, setDeleteDialogeProjectId } from '../actions/defaultActions';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

const DeleteProjectDialogue = ({ _projects, _deleteProjectDialogueId, siteboardAction, setDeleteDialogeProjectId }) => {
  const inputRef = useRef(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');

  // focus input when component is shown
  useEffect(() => {
    //try { inputRef.current.focus(); } catch(error) {}
  }, []);

  const closeDialogue = () => {
    setDeleteDialogeProjectId(null);
  };

  const selectedProject = _deleteProjectDialogueId in _projects ? _projects[_deleteProjectDialogueId] : null;
  if(selectedProject === null) return (<></>);

  return (
    <PopupWindow title='Delete Project' closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
      <div className='max-w-[400px] text-white'>
        <div className=''>
          Delete project <b>"{selectedProject.name}"</b>? This action cannot be undone.
        </div>
        <div className='mt-5'>
          To avoid unintentional deletions, we ask you to provide additional confirmation.
        </div>
        <div className='font-bold mt-5'>
          To confirm this deletion, type "confirm".
        </div>
        <div className='mt-1'>
          <input 
            ref={inputRef}
            className='project-detail-input' 
            type='text' 
            value={deleteConfirmation}
            onChange={(event) => { 
              setDeleteConfirmation(event.target.value); 
            }}
          />
        </div>
        <div className='flex'>
          <div className='w-full flex flex-col justify-center mt-4'>
            <PushButton 
              textColor='white'
              bgColor='bg-red-800'
              hoverBgColor='bg-red-600'
              disabled={deleteConfirmation.toLowerCase() !== 'confirm'}
              onClick={() => {
                if(!selectedProject || selectedProject === {}) { return; }

                siteboardAction(DELETE_PROJECT, {project: selectedProject}, (output) => {
                  closeDialogue();
                  siteboardAction(SET_EDIT_PROJECT_DIALOGUE_ID, { projectId: '' });
                });
              }}
            >
              Delete Project
            </PushButton>
          </div>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _deleteProjectDialogueId: state.localEphemeral.deleteProjectDialogueId,
}};
export default connect(mapStateToProps, { siteboardAction, setDeleteDialogeProjectId })(DeleteProjectDialogue);
